// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import CreatableSelect from 'react-select/creatable';

import Modal from './Modal';
import Checkbox from '../Checkbox';

import '../../styles/modal.css';

export default class DocumentSharing extends Modal {

    state = {
        users: [],
        teams: [],
        emails: [],
        password: null,
        inputEmail: ""
    }

    componentDidMount = async () => this.loadInitialState(this.props.data);

    componentWillReceiveProps = async (next) => {
        if (next.doc === this.props.doc)
            return;
        this.loadInitialState(next.doc);
    }

    loadInitialState = (docId) => {
        const doc = this.props.getDoc(docId);
        const sharing = doc.sharing ? doc.sharing : { users: [], teams: [], protected: { password: "" } };
        this.setState({
            users: sharing.users ? sharing.users : [],
            teams: sharing.teams ? sharing.teams : [],
            emails: sharing.protected.emails ? sharing.protected.emails : [],
            password: sharing.protected.password && sharing.protected.password !== "" ? sharing.protected.password : null
        });
    }

    editSharingSettings = (sharing) => {
        const doc = this.props.getDoc(this.props.data);
        this.props.updateDocument(this.props.data, {
            sharing: {
                ...doc.sharing,
                ...sharing
            }
        });
    }

    getPublicLink = (doc) => "https://my.stax.ai/public/" + doc._id;

    renderContent = () => {
        
        const doc = this.props.data ? this.props.getDoc(this.props.data) : { name: "" };
        const sharing = doc.sharing ? doc.sharing : { public: false };
        
        return (<div className="modal-content modal-center">

            <h1>Document Sharing Settings</h1>

            Who should have access to view the document: <strong>{doc.name}</strong>?

            <h2>Select an access control policy</h2>

            <div style={{
                width: 330,
                margin: "0 auto",
                textAlign: "left"
            }}>
                <Checkbox
                    label="Only users who have access to this stack"
                    checked={!sharing.public && this.state.password === null}
                    onToggle={() => {
                        this.editSharingSettings({
                            public: false,
                            protected: {
                                emails: this.state.emails,
                                password: ""
                            }
                        });
                        this.setState({ password: null });
                    }}
                />

                <Checkbox
                    label="Anyone with the link should have access"
                    checked={sharing.public}
                    onToggle={() => this.editSharingSettings({ public: true })}
                />

                <Checkbox
                    label="Set up a secret password to restrict access"
                    checked={!sharing.public && this.state.password !== null}
                    onToggle={() => {
                        this.editSharingSettings({
                            public: false
                        });
                        this.setState({ password: "" });
                    }}
                />
            </div>

            {/* Open to the public */}
            {sharing.public && <>
                <h2>Public file sharing link</h2>
                <a target="_blank" rel="noopener noreferrer" href={this.getPublicLink(doc)}>{this.getPublicLink(doc)}</a>
                <p className="modal-hint">
                    *<strong>Anyone</strong> with the link can use it to access this document. You have made the document <strong>public</strong>. Please make sure there isn't any personal or private information in this document.
                </p>
            </>}

            {/* Password-protected */}
            {!sharing.public && this.state.password !== null && <>
                <h2>Document access link</h2>
                <a target="_blank" rel="noopener noreferrer" href={this.getPublicLink(doc)}>{this.getPublicLink(doc)}</a>

                <h2>Who should have access?</h2>
                <CreatableSelect
                    components={{ DropdownIndicator: null }}
                    className="multi-select-container modal-multi-select"
                    classNamePrefix="multi-select"
                    placeholder="Type email addresses..."
                    isMulti
                    options={[]}
                    defaultMenuIsOpen={false}

                    value={this.state.emails.map(email => ({
                        label: email,
                        value: email
                    }))}
                    onChange={value => this.setState({
                        emails: value ? value.map(email => email.value) : []
                    })}

                    inputValue={this.state.inputEmail}
                    onInputChange={value => {
                        if (this.state.inputEmail.length > 2 && value === "")
                            this.setState({
                                emails: [
                                    ...this.state.emails,
                                    this.state.inputEmail
                                ],
                                inputEmail: ""
                            });

                        else if (value !== "" || this.state.inputEmail.length === 1)
                            this.setState({
                                inputEmail: value
                            });
                    }}
                />

                <p className="modal-hint">
                    *Leave this empty for <strong>anyone</strong> who has the password to have access.
                </p>

                <h2>Secret word or phrase</h2>

                <div className="modal-password-group">
                    <div style={{
                        float: 'left',
                        width: this.state.password !== "" ? 354 : 550
                    }}>
                        <input
                            type="password"
                            className="modal-password"
                            placeholder="Type password..."
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                        />
                    </div>
                    <div
                        className="modal-button-container"
                        style={{
                            display: this.state.password !== "" ? 'block' : 'none'
                        }}
                    >
                        <div
                            className="button modal-button"
                            style={{
                                clear: 'both',
                                float: 'none',
                                backgroundImage: "url('https://static.stax.ai/images/icons/lock.png')"
                            }}
                            onClick={() => {
                                this.editSharingSettings({
                                    public: false,
                                    protected: {
                                        emails: this.state.emails,
                                        password: this.state.password
                                    }
                                });
                                this.props.modal();
                            }}
                        >Set password</div>
                    </div>
                </div>

            </>}

        </div>);
    }

};